import axios from '@/utils/request'

//创建订单
export function createOrder(data) {
    return axios({
        url: '/my_sign/order',
        method: 'post',
        data
    })
}
//我的订单
export function order(data) {
    return axios({
        url: '/my/order',
        method: 'get',
        params: data
    })
}
//支付
export function pay(data) {
    return axios({
        url: '/my_order/pay',
        method: 'post',
        data
    })
}